import { useState, useEffect } from 'react';

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: 'Sarah Johnson',
      location: 'Monmouth County, NJ',
      rating: 5,
      text: 'Garden State Junk Removal made our estate cleanout so much easier during a difficult time. They were professional, respectful, and incredibly efficient. They even donated items to local charities. Highly recommend their services!',
      image: 'https://public.readdy.ai/ai/img_res/bef4367f98a7c4e02a18ef70a3765462.jpg'
    },
    {
      name: 'Michael Chen',
      location: 'Ocean County, NJ',
      rating: 5,
      text: 'I needed furniture removal for my office renovation and these guys were amazing! They showed up on time, worked quickly, and the pricing was exactly as quoted. No surprises, no hassles. Will definitely use them again.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20smiling%20Asian%20man%20in%20his%20thirties%20wearing%20business%20casual%20shirt%2C%20bright%20natural%20lighting%2C%20clean%20white%20background%2C%20confident%20expression%2C%20high%20quality%20photography&width=200&height=200&seq=testimonial-002&orientation=squarish'
    },
    {
      name: 'Jennifer Martinez',
      location: 'Middlesex County, NJ',
      rating: 5,
      text: 'After our kitchen renovation, we had tons of debris and old appliances. Garden State handled everything perfectly and recycled what they could. Their commitment to environmental responsibility really impressed me. Great service!',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20smiling%20Hispanic%20woman%20with%20long%20dark%20hair%20in%20professional%20attire%2C%20bright%20natural%20lighting%2C%20clean%20white%20background%2C%20warm%20expression%2C%20high%20quality%20photography&width=200&height=200&seq=testimonial-003&orientation=squarish'
    },
    {
      name: 'Robert Williams',
      location: 'Monmouth County, NJ',
      rating: 5,
      text: 'I have been using Garden State Junk Removal for my rental properties for years. They are always reliable, professional, and their prices are fair. The team is courteous and gets the job done right every single time.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20smiling%20senior%20man%20with%20gray%20hair%20in%20casual%20polo%20shirt%2C%20bright%20natural%20lighting%2C%20clean%20white%20background%2C%20friendly%20expression%2C%20high%20quality%20photography&width=200&height=200&seq=testimonial-004&orientation=squarish'
    },
    {
      name: 'Emily Thompson',
      location: 'Ocean County, NJ',
      rating: 5,
      text: 'Fantastic experience from start to finish! They removed all the junk from our garage and basement in just a few hours. The crew was friendly, careful with our property, and left everything clean. Worth every penny!',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20smiling%20young%20woman%20with%20blonde%20hair%20in%20casual%20sweater%2C%20bright%20natural%20lighting%2C%20clean%20white%20background%2C%20cheerful%20expression%2C%20high%20quality%20photography&width=200&height=200&seq=testimonial-005&orientation=squarish'
    },
    {
      name: 'David Patel',
      location: 'Middlesex County, NJ',
      rating: 5,
      text: 'Outstanding service! They helped us clear out years of accumulated items from our parents home. The team was compassionate, efficient, and went above and beyond. I cannot thank them enough for making this process stress-free.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20smiling%20Indian%20man%20in%20his%20forties%20wearing%20glasses%20and%20button-up%20shirt%2C%20bright%20natural%20lighting%2C%20clean%20white%20background%2C%20professional%20expression%2C%20high%20quality%20photography&width=200&height=200&seq=testimonial-006&orientation=squarish'
    }
  ];

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-teal-100 px-4 py-2 rounded-full mb-4">
            <i className="ri-star-line text-teal-600 text-lg"></i>
            <span className="text-teal-700 text-sm font-semibold">Testimonials</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What Our Customers Say
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Over 25 years of trusted service across New Jersey. Read what our satisfied customers have to say about their experience with Garden State Junk Removal.
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          {/* Carousel */}
          <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12 relative overflow-hidden">
            <div className="absolute top-8 left-8 text-teal-600 opacity-20">
              <i className="ri-double-quotes-l text-6xl"></i>
            </div>

            <div className="relative z-10">
              <div className="flex flex-col items-center text-center">
                <div className="w-24 h-24 rounded-full overflow-hidden mb-6 border-4 border-teal-600 shadow-lg">
                  <img
                    src={testimonials[currentIndex].image}
                    alt={testimonials[currentIndex].name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>

                <div className="flex items-center space-x-1 mb-4">
                  {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                  ))}
                </div>

                <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-6 max-w-2xl">
                  "{testimonials[currentIndex].text}"
                </p>

                <h4 className="text-xl font-bold text-gray-900">
                  {testimonials[currentIndex].name}
                </h4>
                <p className="text-sm text-gray-600 flex items-center space-x-1">
                  <i className="ri-map-pin-line"></i>
                  <span>{testimonials[currentIndex].location}</span>
                </p>
              </div>
            </div>
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-teal-600 hover:text-white transition-all group"
            aria-label="Previous testimonial"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-teal-600 hover:text-white transition-all group"
            aria-label="Next testimonial"
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>

          {/* Dots Indicator */}
          <div className="flex items-center justify-center space-x-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2.5 h-2.5 rounded-full transition-all ${
                  index === currentIndex ? 'bg-teal-600 w-8' : 'bg-gray-300'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>

        {/* Trust Badges */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16 max-w-4xl mx-auto">
          <div className="text-center p-6 bg-white rounded-xl shadow-md">
            <i className="ri-shield-check-line text-teal-600 text-4xl mb-2"></i>
            <div className="font-bold text-gray-900 text-sm">Fully Licensed</div>
          </div>
          <div className="text-center p-6 bg-white rounded-xl shadow-md">
            <i className="ri-shield-star-line text-teal-600 text-4xl mb-2"></i>
            <div className="font-bold text-gray-900 text-sm">Insured</div>
          </div>
          <div className="text-center p-6 bg-white rounded-xl shadow-md">
            <i className="ri-leaf-line text-teal-600 text-4xl mb-2"></i>
            <div className="font-bold text-gray-900 text-sm">Eco-Friendly</div>
          </div>
          <div className="text-center p-6 bg-white rounded-xl shadow-md">
            <i className="ri-customer-service-2-line text-teal-600 text-4xl mb-2"></i>
            <div className="font-bold text-gray-900 text-sm">24/7 Support</div>
          </div>
        </div>
      </div>
    </section>
  );
}
